import { Permission } from '@today/types'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'
import { ComplianceDeletionsPage } from './ComplianceDeletionsPage'
import { ComplianceSarsPage } from './ComplianceSarsPage'

export { ComplianceDeletionsPage, ComplianceSarsPage }

/**
 * The compliance admin routes under `/admin` (TO-232 compliance-admin-ui): both
 * need `compliance.read`; without it the Forbidden page renders. Mutating
 * controls are gated inside the pages on their manage permissions.
 */
export const compliancePageRoutes: RouteObject[] = [
	{
		path: 'compliance/deletions',
		element: (
			<RequirePermission permission={Permission.COMPLIANCE_READ}>
				<ComplianceDeletionsPage />
			</RequirePermission>
		),
	},
	{
		path: 'compliance/sars',
		element: (
			<RequirePermission permission={Permission.COMPLIANCE_READ}>
				<ComplianceSarsPage />
			</RequirePermission>
		),
	},
]
